var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 7.00004C3.33317 7.74004 2.73984 8.33337 1.99984 8.33337C1.73613 8.33337 1.47834 8.25518 1.25908 8.10867C1.03981 7.96216 0.868915 7.75392 0.767998 7.51029C0.667082 7.26665 0.640677 6.99856 0.692124 6.73992C0.743571 6.48128 0.870559 6.2437 1.05703 6.05723C1.2435 5.87076 1.48108 5.74377 1.73972 5.69233C1.99836 5.64088 2.26645 5.66728 2.51008 5.7682C2.75372 5.86912 2.96196 6.04002 3.10846 6.25928C3.25497 6.47855 3.33317 6.73633 3.33317 7.00004ZM2.6665 0.333374V4.33337H1.33317V0.333374H2.6665ZM1.33317 13.6667V9.66671H2.6665V13.6667H1.33317ZM15.9998 3.00004V11C15.9998 11.74 15.4065 12.3334 14.6665 12.3334H6.6665C6.31288 12.3334 5.97374 12.1929 5.7237 11.9429C5.47365 11.6928 5.33317 11.3537 5.33317 11V8.33337L3.99984 7.00004L5.33317 5.66671V3.00004C5.33317 2.64642 5.47365 2.30728 5.7237 2.05723C5.97374 1.80718 6.31288 1.66671 6.6665 1.66671H14.6665C15.4065 1.66671 15.9998 2.26004 15.9998 3.00004ZM14.6665 3.00004H6.6665V6.22004L5.8865 7.00004L6.6665 7.78004V11H14.6665V3.00004ZM7.99984 5.00004H13.3332V6.33337H7.99984V5.00004ZM7.99984 7.66671H11.9998V9.00004H7.99984V7.66671Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounded);
export default __webpack_public_path__ + "static/media/founded.4f612f4de5e98c8347f0a8041356e82a.svg";
export { ForwardRef as ReactComponent };